module.exports = __webpack_public_path__ + "media/images/icons/subject_matter_experts-eb58c4d753336f5e5453d702d3c5970e.svg";